var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSnowflake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_94_33625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.011 6.375L4.70465 11.625M14.011 6.375L14.8538 3.30144M14.011 6.375L17.1565 7.19856M4.70465 11.625L1.55908 10.8014M4.70465 11.625L3.8618 14.6986M14.0109 11.6249L4.70459 6.37489M14.0109 11.6249L17.1565 10.8014M14.0109 11.6249L14.8538 14.6985M4.70459 6.37489L3.86191 3.30152M4.70459 6.37489L1.55919 7.19864M9.35781 3.75L9.35781 14.25M9.35781 3.75L7.05509 1.5M9.35781 3.75L11.6605 1.5M9.35781 14.25L7.05509 16.5M9.35781 14.25L11.6605 16.5",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_33625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4217,
    height: 18,
    fill: "white",
    transform: "translate(0.146973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSnowflake);
export default __webpack_public_path__ + "static/media/iconSnowflake.1a94b5622a5c93200021401d74d25853.svg";
export { ForwardRef as ReactComponent };